export default "/images/Construction.webp?2391bc32cd319fd9fecc9092aab8897f";